<template content = "width=device-width">
	<div>
		<div v-if="$route.name === 'survey-list'">
			<v-layout wrap>
				<v-flex xs2>
					<v-select
						class="select-core"
						hide-details
						clearable
						height="17"
						outline
						single-line
						:items="options"
						item-value="id"
						item-text="name"
						v-model="filterPolls"
						@input="filterRow($event)">
					</v-select>
				</v-flex>
				<v-flex xs10>
					<polls-state-filter
						v-if="isEmployee"
						:state="state"
						@input="changeDiagnosisState"
					/>
				</v-flex>
			</v-layout>
			<poll-table
				class="tablePoll"
				:rows="rows"
				:columns="columns"
				:no-actions="state === 2"
				@on-click="goToPoll"
				@on-search="onSearch"
			/>
		</div>
		<router-view name="pollResolve"></router-view>
		<router-view name="customPoll"></router-view>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import pollTable from '@/components/polls/poll-table';
import pollsStateFilter from '@/components/polls/polls-state-filter';
import { format, isBefore, isAfter, subHours } from 'date-fns';
import { isNil } from 'ramda';

function validationDates(dateValidate, value) {
	const currentTime = new Date();
	const options = {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
		hour12: false,
		timeZone: 'America/Guayaquil',
	};
	this.dataTime = format(currentTime, 'YYYY-MM-DD HH:mm:ss', options);
	let validate = null;
	if (value === 'startDate') {
		const date = format(dateValidate, 'YYYY-MM-DD HH:mm:ss');
		validate = isBefore(this.dataTime, date);
	} else {
		const date = format(dateValidate, 'YYYY-MM-DD HH:mm:ss');
		// const date = format(subHours(dateValidate, 5), 'YYYY-MM-DD HH:mm:ss');
		validate = isAfter(this.dataTime, date);
	}
	return validate;
}

async function listPolls() {
	try {
		const query = {
			state: this.state,
		};
		if (this.filterPolls === 1) {
			const response = await this.$http.get('poll-employees/diagnostic', { params: query });
			this.rows = response.data.filter(f => f.diagnostic !== null &&
				f.poll !== null && Object.keys(f.poll).length !== 0).map((r) => {
				const newR = { ...r };
				if (r.tool && r.tool.code === 'JEV') {
					newR.diagnostic.startDate = subHours(r.diagnostic.startDate, 5);
					newR.diagnostic.endDate = subHours(r.diagnostic.endDate, 5);
				}
				newR.diagnosticStartDate = r.diagnostic ?
					format(r.diagnostic.startDate, 'YYYY-MM-DD') : null;
				newR.diagnosticEndDate = r.diagnostic ?
					format(r.diagnostic.endDate, 'YYYY-MM-DD') : null;
				const newStartDate = this.validationDates(r.diagnostic.startDate, 'startDate');
				const newEndDate = this.validationDates(r.diagnostic.endDate, 'endDate');
				newR.flagDates = newStartDate || newEndDate;
				newR.tool = r.tool && r.tool.code ? r.tool.code : '';
				return newR;
			});
		} else if (this.filterPolls === 2) {
			const response = await this.$http.get('poll-employees/process', { params: query });
			this.rows = response.data.map((e) => {
				const newE = { ...e };
				const job = e.employee && e.employee.job ? e.employee.job : {};
				newE.diagnosticStartDate = e.process ?
					format(e.process.startDate, 'YYYY-MM-DD') : null;
				newE.diagnosticEndDate = e.process ?
					format(e.process.endDate, 'YYYY-MM-DD') : null;
				newE.tool = {
					id: e.poll.id,
					code: e.poll.toolCode,
					description: e.poll.toolCode,
					flagActive: e.poll.flagActive,
				};
				let jobName = '';
				if (job != null) {
					if (job.name) {
						jobName = job.name;
						newE.poll.name = `${newE.poll.name} - (${e.employee.name} ${e.employee.lastName}) - (${jobName})`;
					}
				} else {
					newE.poll.name = `${newE.poll.name} - (${e.employee.name} ${e.employee.lastName})`;
				}
				const newStartDate = this.validationDates(e.process.startDate, 'startDate');
				const newEndDate = this.validationDates(e.process.endDate, 'endDate');
				newE.flagDates = newStartDate || newEndDate;
				return newE;
			});
		}
	} catch (error) {
		this.showGenericError();
	}
}

function filterRow(filter) {
	this.filterPolls = filter;
	this.listPolls();
}

function onSearch(searchVal) {
	const newSearch = searchVal ? searchVal.trim() : null;
	this.search = newSearch;
}

// function goToPoll({ id, poll: { urlCode } }) {
function goToPoll(row) {
	if (this.filterPolls === 1) {
		const { id, poll: { urlCode } } = row;
		const newStartDate = this.validationDates(row.diagnostic.startDate, 'startDate');
		const newEndDate = this.validationDates(row.diagnostic.endDate, 'endDate');
		if ((newStartDate || newEndDate) === true) {
			location.reload();
		} else
		if (!isNil(urlCode)) {
			this.goTo(`page-poll-${urlCode}`, { params: { id, filter: this.filterPolls } });
		} else {
			this.goTo('page-polls', { params: { id, filter: this.filterPolls } });
		}
	} else {
		const { process: { id }, employee, poll } = row;
		const newStartDate = this.validationDates(row.process.startDate, 'startDate');
		const newEndDate = this.validationDates(row.process.endDate, 'endDate');
		if ((newStartDate || newEndDate) === true) {
			location.reload();
		} else {
			this.goTo('page-polls', { params: {
				id,
				filter: this.filterPolls,
				employee,
				poll } });
		}
	}
}

function changeDiagnosisState(state) {
	this.state = state;
	this.listPolls();
}

function filterPolls(newValue, oldValue) {
	if (newValue !== oldValue) {
		this.$router.push({ name: 'survey-list', query: { filter: newValue } });
	}
}

function data() {
	return {
		dataTime: null,
		search: null,
		rows: [],
		filterPolls: '',
		columns: [
			{
				id: 1,
				name: 'Nombre de Estudio',
				value: 'name',
				checked: true,
				visible: true,
			},
			{
				id: 2,
				name: 'Fecha Inicio',
				value: 'initDate',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'Fecha Fin',
				value: 'finalDate',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Acciones',
				value: 'actions',
				checked: true,
				visible: true,
			},
		],
		options: [
			{
				id: 1,
				name: 'Diagnósticos',
			},
			{
				id: 2,
				name: 'Evaluación',
			},
		],
		state: 1,
	};
}

export default {
	name: 'page-poll',
	components: {
		pollsStateFilter,
		pollTable,
	},
	computed: {
		...mapState({
			isEmployee: state => state.user.isEmployee,
		}),
	},
	data,
	methods: {
		changeDiagnosisState,
		goToPoll,
		listPolls,
		onSearch,
		filterRow,
		validationDates,
	},
	watch: {
		$route(newVal) {
			if (newVal && (newVal.name === 'survey' || newVal.name === 'survey-list')) {
				this.listPolls();
			}
		},
		filterPolls,
	},
	beforeMount() {
		this.filterPolls = 1;
		this.listPolls();
	},
};
</script>
<style lang="scss" scoped>
@media screen and  (max-width: 950px) {
.tablePoll {
float: left;
width:650px;
}
}

</style>
  


// WEBPACK FOOTER //
// src/pages/polls/page-poll.vue